import React from 'react';

const AnalogClock = ({ hours = 12, minutes = 0, size = 280 }) => {
  const center = 100;
  const radius = 90;

  const minuteAngle = (minutes / 60) * 360 - 90;
  const hourAngle = ((hours % 12) / 12) * 360 + (minutes / 60) * 30 - 90;

  const hourHandLength = 45;
  const minuteHandLength = 65;

  return (
    <svg width={size} height={size} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id="softShadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#000000" floodOpacity="0.1" />
        </filter>
      </defs>

      {/* Циферблат - мягкий кремовый цвет */}
      <circle cx={center} cy={center} r={radius} fill="#FAFAFA" stroke="#E5E0F5" strokeWidth="4" filter="url(#softShadow)" />
      
      {/* Внутренний ободок */}
      <circle cx={center} cy={center} r={radius - 8} fill="none" stroke="#F0F0F5" strokeWidth="2" />

      {/* Часовые деления и цифры */}
      {[...Array(12)].map((_, i) => {
        const angle = (i / 12) * 360 - 90;
        const radian = (angle * Math.PI) / 180;
        
        const x1 = center + Math.cos(radian) * (radius - 10);
        const y1 = center + Math.sin(radian) * (radius - 10);
        const x2 = center + Math.cos(radian) * (radius - 16);
        const y2 = center + Math.sin(radian) * (radius - 16);
        
        const tx = center + Math.cos(radian) * (radius - 28);
        const ty = center + Math.sin(radian) * (radius - 28);
        
        return (
          <g key={i}>
            <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#B0B0C8" strokeWidth="3" strokeLinecap="round" />
            <text 
              x={tx} 
              y={ty} 
              fontSize="14" 
              fontFamily="Inter, sans-serif" 
              fontWeight="700" 
              fill="#4A4A5A" 
              textAnchor="middle" 
              dominantBaseline="central"
            >
              {i === 0 ? 12 : i}
            </text>
          </g>
        );
      })}

      {/* Минутная стрелка (Мягкий синий) */}
      <line 
        x1={center} 
        y1={center} 
        x2={center + minuteHandLength} 
        y2={center} 
        stroke="#3B82F6" 
        strokeWidth="5" 
        strokeLinecap="round"
        transform={`rotate(${minuteAngle} ${center} ${center})`}
      />

      {/* Часовая стрелка (Мягкий красный/коралловый) */}
      <line 
        x1={center} 
        y1={center} 
        x2={center + hourHandLength} 
        y2={center} 
        stroke="#EF4444" 
        strokeWidth="7" 
        strokeLinecap="round"
        transform={`rotate(${hourAngle} ${center} ${center})`}
      />

      {/* Центральная точка */}
      <circle cx={center} cy={center} r="6" fill="#4A4A5A" />
      <circle cx={center} cy={center} r="2" fill="#FAFAFA" />
    </svg>
  );
};

export default AnalogClock;